import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    width: '100%'
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: 32,
    gap: 16,

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginBottom: 24
    }
  },
  title: {
    marginBottom: 24,
    marginTop: 15,
    fontSize: '18px',
    lineHeight: 1.5,

    [theme.breakpoints.down('sm')]: {
      marginBottom: 18,
      marginTop: 15,
      fontSize: '16px'
    }
  },
  searchWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 20,
    marginTop: 0,
    paddingRight: 0,

    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    },

    [theme.breakpoints.down('sm')]: {
      marginBottom: 16
    }
  },
  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,

    [theme.breakpoints.down('sm')]: {
      gap: 4
    }
  },
  noResults: {
    color: theme.palette.text.secondary
  }
}))
